import { isEmpty } from 'lodash';

interface IInput {
  featureFlagToCheck: string;
  featureFlags: Array<string>;
}

export const checkFeatureFlag = ({ featureFlagToCheck, featureFlags }: IInput) => {
  if (isEmpty(featureFlags)) {
    return false;
  }

  return featureFlags.includes(featureFlagToCheck);
}